/**
 ** module: SLTHomePage.js
 ** usage: Component for the home page of the Golden Bear Reserve Neighborhood Directory application.
 **     Provides an overview of features and a sign-in button for property owners.
 ** created: 12/5/25
 ** owner: Rob Blanch
 **/
import React from "react";
import {withRouter} from "react-router-dom";
import "./SLTHomePage.css";

class SLTHomePage extends React.Component {
  /**
   * constructor
   * usage: initializes the SLTHomePage component
   * props:
   *      onSignIn - (mandatory) callback function to handle sign-in action
   */
  constructor(props) {
    super(props);

    var isMissingProps = false;
    var msg = null;
    var error = null;

    if (!props.onSignIn || typeof props.onSignIn !== "function") {
      isMissingProps = true;
      msg = "SLTHomePage: 'onSignIn' prop is required and must be a function";
      error = new Error(msg);
    }

    this.state = {
      isMissingProps: isMissingProps,
      message: msg,
      error: error,
    };
  }

  render() {
    var onSignIn = this.props.onSignIn;
    var onViewMap = this.props.onViewMap;

      return (
        <div className="home-page">
        <header className="home-header">
            <div className="home-logo">
            <div className="home-logo-circle">
                <span className="home-logo-letter">GB</span>
            </div>
            <div className="home-logo-text">
                <div className="home-app-name">Golden Bear Reserve</div>
                <div className="home-app-subtitle">
                Neighborhood Directory &amp; Map
                </div>
            </div>
            </div>

            <button
            className="home-header-button"
            onClick={onSignIn}
            type="button"
            >
            Sign In
            </button>
        </header>

        <main className="home-main">
            {/* Hero / intro */}
            <section className="home-hero-card">
            <div className="home-hero-content">
                <h1 className="home-hero-title">
                Stay connected with your Golden Bear neighbors.
                </h1>
                <p className="home-hero-text">
                The Golden Bear Reserve Neighborhood Directory gives property
                owners an easy, privacy-aware way to view lots, owners, and
                contact details — all in one place.
                </p>

                <div className="home-hero-actions">

                {(onViewMap) ? 
                    <button
                        className="home-secondary-button"
                        type="button"
                        onClick={onViewMap}
                    >
                        View Neighborhood Map
                    </button> : 
                    null}
                </div>

                <p className="home-hero-note">
                Access is limited to Golden Bear Reserve property owners.  
                Need access? Contact the POA to request directory credentials.
                </p>
            </div>

            <div className="home-hero-aside">
                <div className="home-hero-stat-card">
                <div className="home-hero-stat-label">Lots Tracked</div>
                <div className="home-hero-stat-value">50</div>
                </div>
                <div className="home-hero-stat-card">
                <div className="home-hero-stat-label">Private to Owners</div>
                <div className="home-hero-stat-value">Yes</div>
                </div>
                <div className="home-hero-stat-card">
                <div className="home-hero-stat-label">Last Updated</div>
                <div className="home-hero-stat-value">Regularly</div>
                </div>
            </div>
            </section>

            {/* Features */}
            <section className="home-section">
            <h2 className="home-section-title">What you can do</h2>
            <div className="home-feature-grid">
                <article className="home-feature-card">
                <h3 className="home-feature-title">Browse the directory</h3>
                <p className="home-feature-text">
                    View lots and owner information in a clean, scrollable
                    directory. Quickly find neighbors by name, lot, or street.
                </p>
                </article>

                {(onViewMap) ? <article className="home-feature-card">
                <h3 className="home-feature-title">See the neighborhood map</h3>
                <p className="home-feature-text">
                    Visual overview of the Golden Bear Reserve neighborhood with
                    lot boundaries and owner names, optimized for phones and
                    desktops.
                </p>
                </article> : null}

                <article className="home-feature-card">
                <h3 className="home-feature-title">Control your information</h3>
                <p className="home-feature-text">
                    Update your contact details and control what information is
                    visible to other property owners in the directory.
                </p>
                </article>
            </div>
            </section>

            {/* Info / POA note */}
            <section className="home-section home-section--muted">
            <div className="home-info-card">
                <h2 className="home-info-title">Privacy &amp; access</h2>
                <p className="home-info-text">
                The Golden Bear Reserve Directory is provided as a convenience
                for property owners. Access is restricted to owners, and each
                owner controls what contact details they share. Directory data
                is maintained in coordination with the Reserve at Summit Rock POA.
                </p>
                <p className="home-info-text">
                For questions about access, corrections, or POA records, please
                contact the POA using the information on your most recent billing
                statement or official POA communications.
                </p>
            </div>
            </section>
        </main>
        </div>
    );
  }
}

export default withRouter(SLTHomePage);